const accounting = require('accounting');

module.exports = function (amount) {
  let formattedAmount = accounting.formatMoney(amount.amount, amount.symbol);
  return formattedAmount.replace(/\.00$/, '');
};



// WEBPACK FOOTER //
// ./javascripts/components/shared/format_amount.js